import { ethers } from "ethers";
import Onboard from "@web3-onboard/core";
import injectedModule, { ProviderLabel } from "@web3-onboard/injected-wallets";

const fs = require("/assets/appconfig.json");
const CONTRACT_ABI = require("/assets/GlowMoon.json");
const CONTRACT_ADDRESS = fs.jfAddress;
const RPC_URL = fs.inf;

let provider;
let signer;
let contract;
let onboard;
let connected = false;
let timerInterval;
let currentPrice = 0;
let remainingSeconds;

const injected = injectedModule({
    filter: {
        [ProviderLabel.Detected]: true,
    },
});

const ThemingMap = {
    "--w3o-background-color": "#2064bc",
    "--w3o-foreground-color": "#fffffe",
    "--w3o-text-color": "#fffffe",
    "--w3o-border-color": "#85878b",
    "--w3o-action-color": "#fffa00",
    "--w3o-border-radius": "0px",
};

const initializeOnboard = () => {
    onboard = Onboard({
        wallets: [injected],
        chains: [
            {
                id: "0xaa36a7",
                token: "ETH",
                label: "Ethereum Sepolia",
                rpcUrl: RPC_URL,
            },
        ],
        containerElements: {
            accountCenter: "#web3-onboard-modal",
        },
        connect: {
            autoConnectLastWallet: true,
            autoConnectAllPreviousWallet: true,
            disableClose: false,
        },
        theme: ThemingMap,
        accountCenter: {
            desktop: {
                enabled: true,
                minimal: false,
                position: "topRight",
            },
            mobile: {
                enabled: true,
                minimal: false,
                position: "topRight",
            },
        },
    });
};

const getPrice = () => {
    return fetch('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD')
        .then(response => response.json())
        .then(price => {
            console.log(price);
            return price.USD;
        })
};

const updateContractData = () => {
    const fetchContractData = (contractToUse) => {
        contractToUse.getPoolInfo()
            .then(poolInfo => {
                const round = poolInfo[0].toString();
                const time = poolInfo[1].toString();
                const reward = parseFloat(ethers.utils.formatEther(poolInfo[2]));
                const groupsROI = poolInfo[3].toString();

                if (time == 0) {
                    document.querySelector(".round").textContent = `Rounds #${round}. Previous round has ended, add balance to be the first to get the reward.`;
                    document.getElementById("time-text").style.display = "none";
                    clearInterval(timerInterval);
                } else {
                    document.querySelector(".round").textContent = `Rounds #${round}`;
                    document.getElementById("time-text").style.display = "block";
                    // Update timer
                    remainingSeconds = time;
                    updateTimerDisplay();
                    clearInterval(timerInterval);
                    timerInterval = setInterval(updateTimer, 1000);
                }

                document.querySelector(".eth_reward").textContent = `${reward.toFixed(4)} ETH`;
                document.querySelector(".usd_reward").textContent = `$${(reward * currentPrice).toFixed(2)}`;
                document.querySelector(".group_roi").textContent = `${groupsROI}% ROI`;
                if (signer) {
                    contractToUse.getUserInfo()
                        .then(userInfo => {
                            const isCurrentRound = userInfo[0];
                            const balance = ethers.utils.formatEther(userInfo[1]);
                            const withdrawable = ethers.utils.formatEther(userInfo[2]);
                            const userReward = ethers.utils.formatEther(userInfo[3]);
                            const isLeadingGroup = userInfo[4];
                            const isLeader = userInfo[5];

                            document.querySelector(".balance_eth").textContent = balance;
                            document.querySelector(".group_win").textContent = isLeadingGroup ? "winning" : "loosing";

                            if (isLeadingGroup) {
                                document.querySelector(".group_win").style.color = "green";
                            } else {
                                document.querySelector(".group_win").style.color = "red";
                            }

                            document.querySelector(".reward_last").textContent = isLeader ? "winning" : "loosing";
                            if (isLeader) {
                                document.querySelector(".reward_last").style.color = "green";
                            } else {
                                document.querySelector(".reward_last").style.color = "red";
                            }

                            document.querySelector(".withdraw_eth").textContent = withdrawable;
                            document.querySelector(".withdraw_block_eth").textContent = `${withdrawable} ETH`;
                            document.querySelector(".withdraw_block_usd").textContent = `$${(parseFloat(withdrawable) * currentPrice).toFixed(2)}`;
                            document.querySelector(".withdraw_eth_prev").textContent = `${userReward} ETH`;
                            document.querySelector(".withdraw_usd_prev").textContent = `$${(parseFloat(userReward) * currentPrice).toFixed(2)}`;

                            if (isCurrentRound) {
                                document.getElementById("currentWallet1").style.display = "block";
                                document.getElementById("currentWallet2").style.display = "none";
                                if (withdrawable == 0) {
                                    document.getElementById("withdraw-button").disabled = true;
                                    document.getElementById("withdraw-button").classList.add("btn-disabled");
                                } else {
                                    document.getElementById("withdraw-button").disabled = false;
                                    document.getElementById("withdraw-button").classList.remove("btn-disabled");
                                }
                                document.getElementById("withdraw-prev-button").disabled = true;
                                document.getElementById("withdraw-prev-button").classList.add("btn-disabled");
                            } else {
                                document.getElementById("currentWallet1").style.display = "none";
                                document.getElementById("currentWallet2").style.display = "block";
                                document.getElementById("withdraw-button").disabled = true;
                                document.getElementById("withdraw-button").classList.add("btn-disabled");
                                document.getElementById("withdraw-prev-button").disabled = true;
                                document.getElementById("withdraw-prev-button").classList.add("btn-disabled");
                                document.getElementById("withdraw-prev-button").title = "To withdraw reward add any budget to the pool";
                                if (userReward > 0) {
                                    document.querySelector(".withdraw_eth_prev").textContent = `To withdraw reward add any budget to the pool`;
                                }
                            }
                        })
                        .catch(error => {
                            console.error("Error updating user info:", error);
                            resetUIData();
                        });
                } else {
                    // Reset values if user is not connected or on a different network
                    document.querySelector(".balance_eth").textContent = '-';
                    document.querySelector(".group_win").textContent = '-';
                    document.querySelector(".withdraw_eth").textContent = '-';
                    document.querySelector(".reward_last").textContent = '-';
                    document.querySelector(".withdraw_block_eth").textContent = `0.00 ETH`;
                    document.querySelector(".withdraw_block_usd").textContent = `0.00 USD`;
                    document.querySelector(".withdraw_eth_prev").textContent = `0.00 ETH`;
                    document.querySelector(".withdraw_usd_prev").textContent = `0.00 USD`;
                }
            })
            .catch(error => {
                console.error("Error updating contract data:", error);
                resetUIData();
            })
    }

    if (connected) {
        provider.getNetwork()
            .then(network => {
                if (network.chainId !== 11155111) {
                    document.getElementById("purchase-button").disabled = true;
                    document.getElementById("purchase-button").classList.add("btn-disabled");
                } else {
                    document.getElementById("purchase-button").disabled = false;
                    document.getElementById("purchase-button").classList.remove("btn-disabled");
                }
                fetchContractData(contract);
            })
    } else {
        // Initialize a contract with the Infura provider if no wallet is connected
        if (!provider) {
            // Use a non-websocket provider when there's no web3 wallet
             provider = new ethers.providers.JsonRpcProvider(RPC_URL.replace('wss://', 'https://'));
        }
        provider.getNetwork()
            .then(() => {
                contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);
                fetchContractData(contract);
            })
            .catch(error => {
                console.error("Error getting network:", error);
                resetUIData();
            })
    }
};

function updateTimerDisplay() {
    if (remainingSeconds < 0) remainingSeconds = 0;
    let hours = Math.floor(remainingSeconds / 3600);
    let minutes = Math.floor((remainingSeconds % 3600) / 60);
    let seconds = remainingSeconds % 60;

    document.querySelector(".time__item.hours:nth-child(1)").textContent = Math.floor(hours / 10);
    document.querySelector(".time__item.hours:nth-child(2)").textContent = hours % 10;
    document.querySelector(".time__item.mins:nth-child(1)").textContent = Math.floor(minutes / 10);
    document.querySelector(".time__item.mins:nth-child(2)").textContent = minutes % 10;
    document.querySelector(".time__item.seconds:nth-child(1)").textContent = Math.floor(seconds / 10);
    document.querySelector(".time__item.seconds:nth-child(2)").textContent = seconds % 10;
}

function updateTimer() {
    if (remainingSeconds > 0) {
        remainingSeconds--;
        updateTimerDisplay();
    } else {
        clearInterval(timerInterval);
    }
}

function resetUIData() {
    // Reset contract data
    document.querySelector(".round").textContent = "Rounds #-";
    clearInterval(timerInterval);
    document.querySelector(".time__item.hours:nth-child(1)").textContent = '0';
    document.querySelector(".time__item.hours:nth-child(2)").textContent = '0';
    document.querySelector(".time__item.mins:nth-child(1)").textContent = '0';
    document.querySelector(".time__item.mins:nth-child(2)").textContent = '0';
    document.querySelector(".time__item.seconds:nth-child(1)").textContent = '0';
    document.querySelector(".time__item.seconds:nth-child(2)").textContent = '0';
    document.querySelector(".eth_reward").textContent = `-`;
    document.querySelector(".usd_reward").textContent = `-`;
    document.querySelector(".group_roi").textContent = `-`;

    // Reset user-specific data
    document.querySelector(".balance_eth").textContent = "-";
    document.querySelector(".group_win").textContent = "-";
    document.querySelector(".withdraw_eth").textContent = "-";
    document.querySelector(".reward_last").textContent = "-";
    document.querySelector(".withdraw_block_eth").textContent = `0.00 ETH`;
    document.querySelector(".withdraw_block_usd").textContent = `0.00 USD`;
    document.querySelector(".withdraw_eth_prev").textContent = `0.00 ETH`;
    document.querySelector(".withdraw_usd_prev").textContent = `0.00 USD`;

    // Reset input fields and calculated values
    document.querySelector(".bottom-stocks__input").value = "0.01";
    document.querySelector(".stocks-calc__header.eth").textContent = `-`;
    document.querySelector(".stocks-calc__bottom.usd").textContent = `-`;

    // Hide the "In your wallet" section
    document.getElementById("currentWallet1").style.display = "none";
    document.getElementById("currentWallet2").style.display = "none";
}

const subscribeToEvents = () => {
    contract.on("onNewRound", (round) => {
        console.log("New round started:", round.toString());
        updateContractData();
    });

    contract.on("onDeposit", (value) => {
        console.log("Deposit made:", ethers.utils.formatEther(value));
        updateContractData();
    });

    contract.on("onInterestPaid", (value) => {
        console.log("Interest paid:", ethers.utils.formatEther(value));
        updateContractData();
    });

    contract.on("onRewardPaid", (value) => {
        console.log("Reward paid:", ethers.utils.formatEther(value));
        updateContractData();
    });

    contract.on("onRewardAdded", (value) => {
        console.log("Reward added:", ethers.utils.formatEther(value));
        updateContractData();
    });
};

const handleConnectWallet = () => {
    onboard.connectWallet()
        .then(wallets => {
            if (wallets.length > 0) {
                connected = true;
                provider = new ethers.providers.Web3Provider(wallets[0].provider, "any");
                signer = provider.getSigner();
                contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
                provider.getNetwork()
                    .then(network => {
                        if (network.chainId !== 11155111) {
                            alert("Please switch to the Ethereum Sepolia network.");
                            document.getElementById("btn-connect").disabled = false;
                            document.getElementById("purchase-button").disabled = true;
                            document.getElementById("purchase-button").classList.add("btn-disabled");
                            document.getElementById("withdraw-button").disabled = true;
                            document.getElementById("withdraw-prev-button").disabled = true;
                            return;
                        }

                        document.getElementById("purchase-button").disabled = false;
                        document.getElementById("purchase-button").classList.remove("btn-disabled");
                        document.getElementById("withdraw-button").disabled = false;
                        document.getElementById("withdraw-prev-button").disabled = false;

                        subscribeToEvents();
                        updateContractData();
                    })
            }

        })
        .catch(error => {
            console.error("Error connecting wallet:", error);
        })
};

const handlePurchase = () => {
    if (!connected) {
        alert("Please connect your wallet first.");
        return;
    }

    const amountInEth = document.querySelector(".input_for_radio").value;
    const amountInWei = ethers.utils.parseUnits(amountInEth, "ether");

    contract.pool({ value: amountInWei })
        .then(tx => {
            return tx.wait();
        })
        .then(() => {
            console.log("Purchase successful");
            updateContractData();
        })
        .catch(error => {
            console.error("Error during purchase:", error);
        })

};

const handleWithdraw = () => {
    if (!connected) {
        alert("Please connect your wallet first.");
        return;
    }
    contract.withdraw()
        .then(tx => {
            return tx.wait();
        })
        .then(() => {
            console.log("Withdrawal successful:");
            updateContractData();
        })
        .catch(error => {
            console.error("Error during withdrawal:", error);
        })
};

document.getElementById("btn-connect").addEventListener("click", handleConnectWallet);
document.getElementById("purchase-button").addEventListener("click", handlePurchase);
document.getElementById("withdraw-button").addEventListener("click", handleWithdraw);
document.getElementById("withdraw-prev-button").addEventListener("click", handleWithdraw);

const initialize = () => {
    initializeOnboard();
    getPrice()
        .then(price => {
            currentPrice = price;
             // Initialize a contract with the Infura provider if no wallet is connected
            if (!provider) {
                 // Use a non-websocket provider when there's no web3 wallet
               provider = new ethers.providers.JsonRpcProvider(RPC_URL.replace('wss://', 'https://'));
            }
            provider.getNetwork()
            .then(() => {
                contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);
                 if (typeof window.ethereum !== "undefined") {
                         window.ethereum.request({ method: 'eth_accounts' })
                            .then(accounts => {
                                connected = accounts.length > 0;
                                if (connected) {
                                    signer = provider.getSigner();
                                    contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
                                     provider.getNetwork()
                                        .then(network => {
                                              if (network.chainId !== 11155111) {
                                                  document.getElementById("purchase-button").disabled = true;
                                                   document.getElementById("purchase-button").classList.add("btn-disabled");
                                                }
                                                   subscribeToEvents();
                                         })
                                }

                                window.ethereum.on('accountsChanged', (accounts) => {
                                    if (accounts.length > 0) {
                                        connected = true;
                                        signer = provider.getSigner();
                                        contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
                                         provider.getNetwork()
                                            .then(network => {
                                                if (network.chainId !== 11155111) {
                                                    document.getElementById("purchase-button").disabled = true;
                                                    document.getElementById("purchase-button").classList.add("btn-disabled");
                                                } else {
                                                    document.getElementById("purchase-button").disabled = false;
                                                    document.getElementById("purchase-button").classList.remove("btn-disabled");
                                                }
                                              subscribeToEvents();
                                            })
                                        updateContractData();
                                    } else {
                                        connected = false;
                                        updateContractData();
                                    }
                                });

                                window.ethereum.on('chainChanged', (chainId) => {
                                    provider.getNetwork()
                                        .then(network => {
                                            if (network.chainId !== 11155111) {
                                                document.getElementById("purchase-button").disabled = true;
                                                document.getElementById("purchase-button").classList.add("btn-disabled");
                                            } else {
                                                document.getElementById("purchase-button").disabled = false;
                                                 document.getElementById("purchase-button").classList.remove("btn-disabled");
                                            }
                                           updateContractData();
                                        })
                                });
                            })
                             .catch(error => {
                                console.error("Error during initial wallet connection:", error);
                             })
                    }
                     updateContractData();
            })
            .catch(error => {
                 console.error("Error getting network:", error);
                 resetUIData();
            })
        })
};


initialize();

const currentWalletSection = document.getElementById("currentWallet1");
const previousWalletSection = document.getElementById("currentWallet2");
currentWalletSection.style.display = "none";
previousWalletSection.style.display = "none";

// Handle clicks on the radio buttons for amount selection
document.querySelectorAll(".stocks__header input[type='radio']").forEach((radio) => {
    radio.addEventListener("change", () => {
        const selectedAmount = radio.value;
        document.querySelector(".bottom-stocks__input").value = selectedAmount;
        updateEthAndUsdDisplay(selectedAmount);
    });
});

// Handle direct input in the "cents" input field
document.querySelector(".bottom-stocks__input").addEventListener("input", () => {
    const amountInEth = document.querySelector(".bottom-stocks__input").value;
    // Update the radio button selection based on the input value
    const matchingRadio = document.querySelector(`.stocks__header input[type='radio'][value='${amountInEth}']`);
    if (matchingRadio) {
        matchingRadio.checked = true;
    } else {
        // If the input value does not match any radio button value, uncheck all radio buttons
        document.querySelectorAll(".stocks__header input[type='radio']").forEach((radio) => {
            radio.checked = false;
        });
    }
    updateEthAndUsdDisplay(amountInEth);
});

// Function to update ETH and USD display based on selected amount
function updateEthAndUsdDisplay(amountInEth) {
    const ethValue = parseFloat(amountInEth).toFixed(4);
    const usdValue = ethValue * currentPrice;

    document.querySelector(".stocks-calc__header.eth").textContent = `${ethValue} ETH`;
    document.querySelector(".stocks-calc__bottom.usd").textContent = `$${usdValue.toFixed(2)}`;
}

// Set the initial value of the input field to 0.01 when the page loads
document.addEventListener('DOMContentLoaded', () => {
    document.querySelector(".bottom-stocks__input").value = "0.01";
    updateEthAndUsdDisplay("0.01"); // Also update the ETH/USD display initially
});

// Periodically update contract data (e.g., every 30 seconds)
setInterval(updateContractData, 30000);